import { render } from "./RecordsCreateMenu.vue?vue&type=template&id=92e4ed88"
import script from "./RecordsCreateMenu.vue?vue&type=script&lang=js"
export * from "./RecordsCreateMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
